import React from 'react';
import Img from 'gatsby-image';

export default props => (
  <section className="side-image clearfix" id="aboutRodo">
    <div className="image-container col-md-5 pull-left">
      {/* <div>
        <img
          className="side-image-left side-image-img"
          alt="Background"
          src="https://source.unsplash.com/yekGLpc3vro/1000x1200"
        />
      </div> */}
      <Img
        resolutions={props.image.resolutions}
        imgStyle={{ objectPosition: '100%' }}
        className="image-full-width"
        outerWrapperClassName="image-full-width"
      />
    </div>

    <div className="container">
      <div className="row">
        <div className="col-md-7 col-md-offset-6 col-sm-12 content clearfix pr-100">
          <h1>O co chodzi z RODO?</h1>
          <p className="lead">
            RODO wchodzi w życie w 28 państwach członkowskich UE od 25 maja 2018 roku. Regulacje zawarte w
            rozporządzeniu narzucają nowe obowiązki dla firm w procesach ochrony danych osobowych osób fizycznych.
            Obejmują więc firmy zatrudniające chociaż jednego pracownika lub przetwarzające dane osób fizycznych, np.
            adres email. W związku z tym, nowemu rozporządzeniu podlegają praktycznie wszyscy przedsiębiorcy.
          </p>
          <h1>Katastrofalne konsekwencje</h1>
          <p className="lead">
            Zmiany, które firmy muszą wprowadzić w sposobach zarządzania danymi są poważne, a potencjalne kary za ich
            bagatelizację ogromne. Na firmę, która nie dostosuje się do wymagań nowych przepisów może zostać nałożona
            kara finansowa do wysokości 10 000 000 € lub 2% światowego obrotu rocznego brutto za poprzedni rok. W
            przypadku znaczącego naruszenia postanowień rozporządzenia kwota może wzrosnąć do 20 000 000 € lub 4%
            światowego obrotu brutto. W obu przypadkach zawsze wybierana jest wyższa wartość.
          </p>
        </div>
      </div>
    </div>
  </section>
);



// WEBPACK FOOTER //
// ./src/components/AboutRodo.js